<template>
  <v-dialog
    v-model="show"
    persistent
    width="1200px"
    scrollable
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <v-card flat>
      <v-card-title>
        <div>Reschedule Class</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="6">
                <div class="label mb-2">Class Date</div>
                <v-menu
                  ref="classDateMenu"
                  v-model="classDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.class_date"
                      :rules="[validationRules.required]"
                      placeholder="Select class date"
                      prepend-icon="mdi-calendar"
                      solo
                      flat
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.class_date"
                    @change="$refs.classDateMenu.save($event)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <div class="label mb-2">Class Time</div>
                <v-row align="center" dense>
                  <v-col cols="auto">
                    <time-picker
                      v-model="form.start_time"
                      class="vue__time-picker--dense mb-6"
                      input-width="100px"
                      close-on-complete
                      manual-input
                    />
                  </v-col>
                  <span class="mb-6">-</span>
                  <v-col cols="auto">
                    <time-picker
                      v-model="form.end_time"
                      class="vue__time-picker--dense mb-6"
                      input-width="100px"
                      close-on-complete
                      manual-input
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end">
            <v-col md="3" cols="12">
              <v-btn block depressed outlined @click="show = false">
                Cancel
              </v-btn>
            </v-col>
            <v-col md="3" cols="12">
              <v-btn
                block
                depressed
                color="primary"
                :disabled="isLoading"
                @click="submit"
              >
                Save Changes
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'RescheduleDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      classDateMenu: false,
      form: {
        class_date: null,
        start_time: '',
        end_time: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'classroomSchedule/isDetailLoading',
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      updateSchedule: 'classroomSchedule/update',
      handleError: 'handleError',
    }),
    init() {
      _.merge(this.form, this.item)
    },
    resetForm() {
      this.form = {
        class_date: null,
        start_time: '',
        end_time: '',
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const err = await this.updateSchedule(this.form)
        if (!err) {
          this.$emit('submit', this.form)
          this.$emit('update:item', this.form)
        }
      }
    },
  },
}
</script>
